import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isInterface3d6p8outrmvmk as isInterface,
  VOID7hggqo3abtya as VOID,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Unit_instanceat14thlj150z as Unit_instance,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  getKClass1s3j9wy1cofik as getKClass,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  KClass1cc9rfeybg8hs as KClass,
  toString1pkumu07cwy4m as toString,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  get_EmptyContinuationn1rwa6yr6j5w as get_EmptyContinuation,
  startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion,
  Exceptiondt2hlxn7j7vw as Exception,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  numberToDouble210hrknaofnhf as numberToDouble,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  toSet2orjxp16sotqu as toSet,
  removeAll3o43e67jmwdpc as removeAll,
  toMutableList20rdgwi7d3cwi as toMutableList,
  round2mrvepag8eey0 as round,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
} from './kotlin-kotlin-stdlib.mjs';
import {
  GameState3q77fz75jxadj as GameState,
  ClientContext1mhsfx1tilrk5 as ClientContext,
  PacketHandler113i5gse3aexx as PacketHandler,
  MapChunkUpdatePacketczpeqvhxthl7 as MapChunkUpdatePacket,
  MapDataPacket1xeubpx5tzkn3 as MapDataPacket,
  Companion_getInstance2mholsbmtd60v as Companion_getInstance,
  PacketDispatcher3c6u6w753k1f7 as PacketDispatcher,
  Companion_getInstanceylu41py2t57r as Companion_getInstance_0,
  MovePacket3tg8qd21dxvdk as MovePacket,
  AuthHandshakeRequest2cqt4ejyhdsww as AuthHandshakeRequest,
  LoginRequest33qo5tlvlqop3 as LoginRequest,
  RegisterRequest71c0d4m3i6t as RegisterRequest,
  AuthHandshakeResponsecnd8rs5it2d0 as AuthHandshakeResponse,
  AuthStatusResponse2dgawm05ssn66 as AuthStatusResponse,
} from './korge-hello-world-client-server-shared.mjs';
import {
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance1j5nd3fbu9uao as Companion_getInstance_1,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  Companion_getInstanceeqp3ibr2vvu9 as Companion_getInstance_2,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Korge3fi4cwjkh8up9 as Korge,
  get_AlphaTransition23l7sd982osvm as get_AlphaTransition,
  withEasingtnol1eyyo9sf as withEasing,
  views116j359zi8nvf as views,
  findFirstAscendante8nli1jx4t64 as findFirstAscendant,
  FixedSizeContainersre0rworj71w as FixedSizeContainer,
  SceneContainer99ijjqni12hp as SceneContainer,
  addTo25e29vq105prw as addTo,
  Companion_getInstance2b4rje0hs8ulh as Companion_getInstance_3,
  Stage1ggtrzujnnkl0 as Stage,
  Container7486fjmip554 as Container,
  Image1b2d7ghyim7p5 as Image,
  xy1gb51vhy014mx as xy,
  scalea9fc0mbrr7ub as scale,
  Companion_instance2ffk2psxndlag as Companion_instance,
  Sprite19oods84ct31j as Sprite,
  anchor3c5itxst996yy as anchor,
  Companion_instance1qzytx5vkv693 as Companion_instance_0,
  Text3kimhvgfxflj3 as Text,
  addUpdater1la23qj9g2d42 as addUpdater,
  addFixedUpdaterkdt88bj87xku as addFixedUpdater,
  Scenezu810y12qpqp as Scene,
  SolidRect131p7hyzlx7j8 as SolidRect,
  UITextInput3hf6kt3o0p9up as UITextInput,
  Companion_getInstancequ1o8fwft10r as Companion_getInstance_4,
  UIButton259u54yn72ttw as UIButton,
  get_mouse1jstwhfaumelj as get_mouse,
} from './korge-root-korge.mjs';
import {
  WebSocketClient1u0rdag4ixzbi as WebSocketClient,
  Resources1ysf2j4wd5yk7 as Resources,
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediately11za8mkid9pxu as launchImmediately,
} from './korlibs-io-root-korlibs-io.mjs';
import { Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_5 } from './korlibs-math-core-root-korlibs-math-core.mjs';
import { get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD } from './korlibs-math-root-korlibs-math.mjs';
import { Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance } from './korlibs-logger-root-korlibs-logger.mjs';
import { Default_getInstance2gwvwo2enihch as Default_getInstance } from './kotlinx-serialization-kotlinx-serialization-protobuf.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  GlobalScope_instance3m5vaygder2s9 as GlobalScope_instance,
  launch1c91vkjzdi9sd as launch,
} from './kotlinx-coroutines-core.mjs';
import {
  slice2pfxfvku0ybgy as slice,
  extractrn4rijx1x4kx as extract,
  readBitmapdk80pcjw6p8f as readBitmap,
  readTtfFont159as20nksus9 as readTtfFont,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  Companion_getInstancezw1wxvwtmh0g as Companion_getInstance_6,
  get_DefaultStringTextRendererdyzggul2pyry as get_DefaultStringTextRenderer,
} from './korlibs-image-root-korlibs-image.mjs';
import { get_timesPerSecond1juuclsmjle05 as get_timesPerSecond } from './korlibs-time-root-korlibs-time.mjs';
import {
  Key_W_getInstance1e55atnxjyziq as Key_W_getInstance,
  Key_S_getInstance3a623w26n65ct as Key_S_getInstance,
  Key_A_getInstance2hm1ual2b01a9 as Key_A_getInstance,
  Key_D_getInstance2xm6ey9bthxfr as Key_D_getInstance,
} from './korge-root-korge-core.mjs';
import { get_secondsjblpw5qd4dzj as get_seconds } from './korlibs-time-root-korlibs-time-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
//endregion
//region block: pre-declaration
class UserSession {
  constructor() {
    this.cde_1 = '';
    this.dde_1 = '';
    this.ede_1 = '';
    this.fde_1 = null;
  }
}
class GameStateHandler {
  constructor(gameContext) {
    this.gde_1 = gameContext;
  }
  hde(packet, context, $completion) {
    this.gde_1.ide(packet.ld9_1);
  }
  jdc(packet, context, $completion) {
    var tmp = packet instanceof GameState ? packet : THROW_CCE();
    return this.hde(tmp, (!(context == null) ? isInterface(context, ClientContext) : false) ? context : THROW_CCE(), $completion);
  }
}
class MapChunkUpdateHandler {
  constructor(context) {
    this.jde_1 = context;
  }
  kde(packet, context, $completion) {
    this.jde_1.lde(packet.yd9_1, packet.zd9_1);
  }
  jdc(packet, context, $completion) {
    var tmp = packet instanceof MapChunkUpdatePacket ? packet : THROW_CCE();
    return this.kde(tmp, (!(context == null) ? isInterface(context, ClientContext) : false) ? context : THROW_CCE(), $completion);
  }
}
class MapDataHandler {
  constructor(context) {
    this.mde_1 = context;
  }
  nde(packet, context, $completion) {
    this.mde_1.ode(packet.dda_1);
  }
  jdc(packet, context, $completion) {
    var tmp = packet instanceof MapDataPacket ? packet : THROW_CCE();
    return this.nde(tmp, (!(context == null) ? isInterface(context, ClientContext) : false) ? context : THROW_CCE(), $completion);
  }
}
class main$slambda {
  l9g($this$Korge, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$Korge), $completion);
  }
  qd(p1, $completion) {
    return this.l9g(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class GameConnection$lambda$slambda {
  constructor($bytes, this$0) {
    this.pde_1 = $bytes;
    this.qde_1 = this$0;
  }
  w1n($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
  }
  qd(p1, $completion) {
    return this.w1n((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameConnection {
  constructor(ws) {
    this.rde_1 = ws;
    this.sde_1 = new KorGeClientContext(this.rde_1);
    this.tde_1 = new PacketDispatcher();
    this.rde_1.l33_1.y1v(GameConnection$lambda(this));
  }
}
class KorGeClientContext {
  constructor(ws) {
    this.ude_1 = ws;
  }
  vde(packet, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_send__qhx0g0.bind(VOID, this, packet), $completion);
  }
}
class TargetPos {
  constructor(x, y) {
    this.vdf_1 = x;
    this.wdf_1 = y;
  }
  toString() {
    return 'TargetPos(x=' + this.vdf_1 + ', y=' + this.wdf_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.vdf_1);
    result = imul(result, 31) + getNumberHashCode(this.wdf_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TargetPos))
      return false;
    var tmp0_other_with_cast = other instanceof TargetPos ? other : THROW_CCE();
    if (!equals(this.vdf_1, tmp0_other_with_cast.vdf_1))
      return false;
    if (!equals(this.wdf_1, tmp0_other_with_cast.wdf_1))
      return false;
    return true;
  }
}
class GameScene$sceneMain$gameContext$1 {
  constructor(this$0, $localPlayerView, $playerAnimation, $pixelFont) {
    this.ydf_1 = this$0;
    this.zdf_1 = $localPlayerView;
    this.adg_1 = $playerAnimation;
    this.bdg_1 = $pixelFont;
    this.xdf_1 = this$0.idf_1.ede_1;
  }
  ide(players) {
    var tmp0_elvis_lhs = this.xdf_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var myId = tmp;
    var tmp1_elvis_lhs = this.ydf_1.ndf_1;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var map = tmp_0;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(players, 10));
    var tmp0_iterator = players.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.samples.clientserver.scenes.<no name provided>.updateGameState.<anonymous>' call
      var tmp$ret$0 = item.qd9_1;
      destination.h(tmp$ret$0);
    }
    var activeIds = toSet(destination);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.ydf_1.jdf_1.d3();
    var destination_0 = ArrayList.h1();
    var tmp0_iterator_0 = this_0.a1();
    while (tmp0_iterator_0.b1()) {
      var element = tmp0_iterator_0.c1();
      // Inline function 'korlibs.samples.clientserver.scenes.<no name provided>.updateGameState.<anonymous>' call
      if (!(element === myId) && !activeIds.w2(element)) {
        destination_0.h(element);
      }
    }
    var inactiveIds = destination_0;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_1 = inactiveIds.a1();
    while (tmp0_iterator_1.b1()) {
      var element_0 = tmp0_iterator_1.c1();
      // Inline function 'korlibs.samples.clientserver.scenes.<no name provided>.updateGameState.<anonymous>' call
      var view = this.ydf_1.jdf_1.f3(element_0);
      if (view == null)
        null;
      else {
        view.wai();
      }
      this.ydf_1.ldf_1.f3(element_0);
      this.ydf_1.mdf_1.f3(element_0);
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_2 = players.a1();
    while (tmp0_iterator_2.b1()) {
      var element_1 = tmp0_iterator_2.c1();
      // Inline function 'korlibs.samples.clientserver.scenes.<no name provided>.updateGameState.<anonymous>' call
      if (element_1.qd9_1 === myId) {
        removeAll(this.ydf_1.kdf_1, GameScene$sceneMain$o$updateGameState$lambda(element_1));
        var radius = 6.0;
        var reconciledX = element_1.rd9_1;
        var reconciledY = element_1.sd9_1;
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator_3 = this.ydf_1.kdf_1.a1();
        while (tmp0_iterator_3.b1()) {
          var element_2 = tmp0_iterator_3.c1();
          // Inline function 'korlibs.samples.clientserver.scenes.<no name provided>.updateGameState.<anonymous>.<anonymous>' call
          if (!(element_2.rda_1 === 0.0)) {
            reconciledX = map.ndd(reconciledX, reconciledY, element_2.rda_1, 3.75, radius);
          }
          if (!(element_2.sda_1 === 0.0)) {
            reconciledY = map.odd(reconciledX, reconciledY, element_2.sda_1, 3.75, radius);
          }
        }
        var currentX = this.zdf_1.t6a();
        var currentY = this.zdf_1.u6a();
        var dx = reconciledX - currentX;
        var dy = reconciledY - currentY;
        var distanceSquared = dx * dx + dy * dy;
        var threshold = 5.0;
        if (distanceSquared > threshold * threshold) {
          // Inline function 'korlibs.korge.view.xy' call
          var this_1 = this.zdf_1;
          var x = reconciledX;
          var y = reconciledY;
          xy(this_1, numberToDouble(x), numberToDouble(y));
        } else {
          var _receiver__tnumb7 = this.zdf_1;
          _receiver__tnumb7.fah(_receiver__tnumb7.t6a() + dx * 0.2);
          var _receiver__tnumb7_0 = this.zdf_1;
          _receiver__tnumb7_0.gah(_receiver__tnumb7_0.u6a() + dy * 0.2);
        }
      } else {
        var isNew = false;
        // Inline function 'kotlin.collections.getOrPut' call
        var this_2 = this.ydf_1.jdf_1;
        var key = element_1.qd9_1;
        var value = this_2.c3(key);
        var tmp_1;
        if (value == null) {
          // Inline function 'korlibs.samples.clientserver.scenes.<no name provided>.updateGameState.<anonymous>.<anonymous>' call
          isNew = true;
          // Inline function 'korlibs.korge.view.container' call
          var this_3 = _get_worldContainer__rhqz38(this.ydf_1);
          // Inline function 'korlibs.korge.view.addTo' call
          var this_4 = Container.na3(false);
          // Inline function 'kotlin.apply' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.container.<anonymous>' call
          var otherContainer = addTo(this_4, this_3);
          // Inline function 'kotlin.apply' call
          // Inline function 'korlibs.korge.view.sprite' call
          var initialAnimation = this.adg_1;
          var anchor_0 = Companion_getInstance_2().f24_1;
          // Inline function 'korlibs.korge.view.addTo' call
          var this_5 = Sprite.lcn(initialAnimation, anchor_0);
          // Inline function 'kotlin.apply' call
          var this_6 = addTo(this_5, otherContainer);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.sprite.<anonymous>' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.samples.clientserver.scenes.<no name provided>.updateGameState.<anonymous>.<anonymous>.<anonymous>' call
          this_6.xc1_1 = false;
          // Inline function 'korlibs.korge.view.anchor' call
          anchor(this_6, Anchor2D.s24(numberToDouble(0.5), numberToDouble(0.5)));
          var otherSprite = this_6;
          // Inline function 'korlibs.time.seconds' call
          var tmp$ret$17 = toDuration(0.2, DurationUnit_SECONDS_getInstance());
          otherSprite.pcn(VOID, tmp$ret$17);
          // Inline function 'kotlin.apply' call
          var tmp0_text = element_1.ud9_1;
          var tmp1_color = Colors_getInstance().s3y_1;
          var tmp2_alignment = Companion_getInstance_6().y4w_1;
          // Inline function 'korlibs.korge.view.text' call
          var font = this.bdg_1;
          var renderer = get_DefaultStringTextRenderer();
          var autoScaling = Companion_instance_0.ubo_1;
          // Inline function 'korlibs.korge.view.addTo' call
          var this_7 = Text.vbo(tmp0_text, numberToDouble(4.0), tmp1_color, font, tmp2_alignment, renderer, autoScaling, null, null);
          // Inline function 'kotlin.apply' call
          var this_8 = addTo(this_7, otherContainer);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.text.<anonymous>' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.samples.clientserver.scenes.<no name provided>.updateGameState.<anonymous>.<anonymous>.<anonymous>' call
          this_8.jao_1 = false;
          // Inline function 'korlibs.korge.view.xy' call
          var y_0 = -20.0;
          xy(this_8, numberToDouble(0.0), numberToDouble(y_0));
          var nametag = this_8;
          // Inline function 'kotlin.collections.set' call
          var this_9 = this.ydf_1.ldf_1;
          var key_0 = element_1.qd9_1;
          this_9.e3(key_0, nametag);
          var answer = otherContainer;
          this_2.e3(key, answer);
          tmp_1 = answer;
        } else {
          tmp_1 = value;
        }
        var view_0 = tmp_1;
        if (isNew) {
          // Inline function 'korlibs.korge.view.xy' call
          var x_0 = element_1.rd9_1;
          var y_1 = element_1.sd9_1;
          xy(view_0, numberToDouble(x_0), numberToDouble(y_1));
        } else {
          var tmp0_safe_receiver = this.ydf_1.ldf_1.c3(element_1.qd9_1);
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.lal(element_1.ud9_1);
          }
        }
        // Inline function 'kotlin.collections.set' call
        var this_10 = this.ydf_1.mdf_1;
        var key_1 = element_1.qd9_1;
        var value_0 = new TargetPos(element_1.rd9_1, element_1.sd9_1);
        this_10.e3(key_1, value_0);
      }
    }
  }
  ode(map) {
    this.ydf_1.ndf_1 = map;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.ydf_1.pdf_1.i3().a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.samples.clientserver.scenes.<no name provided>.setMap.<anonymous>' call
      element.wai();
    }
    this.ydf_1.pdf_1.h3();
    this.ydf_1.qdf_1.h3();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = map.ddd_1.a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.samples.clientserver.scenes.<no name provided>.setMap.<anonymous>' call
      // Inline function 'korlibs.korge.view.container' call
      var this_0 = _get_worldContainer__rhqz38(this.ydf_1);
      // Inline function 'korlibs.korge.view.addTo' call
      var this_1 = Container.na3(false);
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.container.<anonymous>' call
      var lContainer = addTo(this_1, this_0);
      // Inline function 'kotlin.collections.set' call
      var this_2 = this.ydf_1.pdf_1;
      var key = element_0.jdd_1;
      this_2.e3(key, lContainer);
      _get_worldContainer__rhqz38(this.ydf_1).qag(lContainer, 0);
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_1 = element_0.hdd_1.a1();
      while (tmp0_iterator_1.b1()) {
        var element_1 = tmp0_iterator_1.c1();
        // Inline function 'korlibs.samples.clientserver.scenes.<no name provided>.setMap.<anonymous>.<anonymous>' call
        renderChunk(this.ydf_1, element_0.jdd_1, element_1);
      }
    }
  }
  lde(layerName, chunk) {
    var tmp0_elvis_lhs = this.ydf_1.ndf_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var map = tmp;
    // Inline function 'kotlin.collections.map' call
    var this_0 = map.ddd_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.samples.clientserver.scenes.<no name provided>.updateMapChunk.<anonymous>' call
      var tmp_0;
      if (item.jdd_1 === layerName) {
        var newChunks = toMutableList(item.hdd_1);
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.indexOfFirst' call
          var index = 0;
          var tmp0_iterator_0 = newChunks.a1();
          while (tmp0_iterator_0.b1()) {
            var item_0 = tmp0_iterator_0.c1();
            // Inline function 'korlibs.samples.clientserver.scenes.<no name provided>.updateMapChunk.<anonymous>.<anonymous>' call
            if (item_0.tdc_1 === chunk.tdc_1 && item_0.udc_1 === chunk.udc_1) {
              tmp$ret$1 = index;
              break $l$block;
            }
            index = index + 1 | 0;
          }
          tmp$ret$1 = -1;
        }
        var chunkIndex = tmp$ret$1;
        if (!(chunkIndex === -1)) {
          newChunks.k3(chunkIndex, chunk);
        } else {
          newChunks.h(chunk);
        }
        tmp_0 = item.wdd(newChunks);
      } else {
        tmp_0 = item;
      }
      var tmp$ret$2 = tmp_0;
      destination.h(tmp$ret$2);
    }
    var newLayers = destination;
    this.ydf_1.ndf_1 = map.qdd(VOID, VOID, VOID, VOID, newLayers);
    renderChunk(this.ydf_1, layerName, chunk);
  }
}
class GameScene$sceneMain$lambda$slambda {
  constructor($conn, $moveData) {
    this.wde_1 = $conn;
    this.xde_1 = $moveData;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
  }
}
class GameScene extends Scene {
  constructor(session) {
    super();
    this.idf_1 = session;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.jdf_1 = LinkedHashMap.bc();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.kdf_1 = ArrayList.h1();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.ldf_1 = LinkedHashMap.bc();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_2.mdf_1 = LinkedHashMap.bc();
    this.ndf_1 = null;
    var tmp_3 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_3.pdf_1 = LinkedHashMap.bc();
    var tmp_4 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_4.qdf_1 = LinkedHashMap.bc();
    var tmp_5 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_5.sdf_1 = LinkedHashMap.bc();
    this.tdf_1 = 16;
    this.udf_1 = 17;
  }
  da6(_this__u8e3s4, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneMain__5xvlzl.bind(VOID, _this__u8e3s4, this), $completion);
  }
}
class LoginScene$sceneMain$o$handle$slambda {
  constructor($packet, this$0, $statusText, $this_sceneMain, $pixelFont, $conn) {
    this.cdg_1 = $packet;
    this.ddg_1 = this$0;
    this.edg_1 = $statusText;
    this.fdg_1 = $this_sceneMain;
    this.gdg_1 = $pixelFont;
    this.hdg_1 = $conn;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
  }
}
class LoginScene$sceneMain$o$handle$slambda_0 {
  constructor($packet, this$0) {
    this.tdg_1 = $packet;
    this.udg_1 = this$0;
  }
  pd($completion) {
    if (this.tdg_1.cdb_1) {
      saveSessionToken(this.tdg_1.edb_1);
      this.udg_1.sdg_1.dde_1 = this.tdg_1.edb_1;
    }
  }
}
class LoginScene$showLoginRegisterUI$o$handle$slambda {
  constructor($packet, $errorText) {
    this.ydg_1 = $packet;
    this.zdg_1 = $errorText;
  }
  pd($completion) {
    if (!this.ydg_1.cdb_1) {
      // Inline function 'kotlin.text.uppercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = this.ydg_1.ddb_1.toUpperCase();
      this.zdg_1.lal(tmp$ret$1);
    }
  }
}
class _no_name_provided__qut3iv {
  constructor(this$0, $statusText, $this_sceneMain, $pixelFont, $conn) {
    this.idh_1 = this$0;
    this.jdh_1 = $statusText;
    this.kdh_1 = $this_sceneMain;
    this.ldh_1 = $pixelFont;
    this.mdh_1 = $conn;
  }
  ndh(packet, context, $completion) {
    launchImmediately(this.idh_1, LoginScene$sceneMain$o$handle$slambda_1(packet, this.idh_1, this.jdh_1, this.kdh_1, this.ldh_1, this.mdh_1));
    return Unit_instance;
  }
  jdc(packet, context, $completion) {
    var tmp = packet instanceof AuthHandshakeResponse ? packet : THROW_CCE();
    return this.ndh(tmp, (context == null ? true : !(context == null)) ? context : THROW_CCE(), $completion);
  }
}
class _no_name_provided__qut3iv_0 {
  constructor(this$0) {
    this.odh_1 = this$0;
  }
  pdh(packet, context, $completion) {
    launchImmediately(this.odh_1, LoginScene$sceneMain$o$handle$slambda_2(packet, this.odh_1));
    return Unit_instance;
  }
  jdc(packet, context, $completion) {
    var tmp = packet instanceof AuthStatusResponse ? packet : THROW_CCE();
    return this.pdh(tmp, (context == null ? true : !(context == null)) ? context : THROW_CCE(), $completion);
  }
}
class LoginScene$sceneMain$slambda {
  constructor($conn, this$0, $statusText) {
    this.vdg_1 = $conn;
    this.wdg_1 = this$0;
    this.xdg_1 = $statusText;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
  }
}
class _no_name_provided__qut3iv_1 {
  constructor(this$0, $errorText) {
    this.qdh_1 = this$0;
    this.rdh_1 = $errorText;
  }
  pdh(packet, context, $completion) {
    launchImmediately(this.qdh_1, LoginScene$showLoginRegisterUI$o$handle$slambda_0(packet, this.rdh_1));
    return Unit_instance;
  }
  jdc(packet, context, $completion) {
    var tmp = packet instanceof AuthStatusResponse ? packet : THROW_CCE();
    return this.pdh(tmp, (context == null ? true : !(context == null)) ? context : THROW_CCE(), $completion);
  }
}
class LoginScene$showLoginRegisterUI$lambda$slambda {
  constructor($conn, $user, $pass, $errorText) {
    this.adh_1 = $conn;
    this.bdh_1 = $user;
    this.cdh_1 = $pass;
    this.ddh_1 = $errorText;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
  }
}
class LoginScene$showLoginRegisterUI$lambda$slambda_0 {
  constructor($conn, $user, $pass, $errorText) {
    this.edh_1 = $conn;
    this.fdh_1 = $user;
    this.gdh_1 = $pass;
    this.hdh_1 = $errorText;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
  }
}
class LoginScene extends Scene {
  constructor(session) {
    super();
    this.sdg_1 = session;
  }
  da6(_this__u8e3s4, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneMain__5xvlzl_0.bind(VOID, _this__u8e3s4, this), $completion);
  }
}
//endregion
function main($completion) {
  var tmp = Size2D.l26(800, 600);
  return Korge(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, main$slambda_0(), $completion);
}
function *_generator_invoke__zhh2q8($this, $this$Korge, $completion) {
  var session = new UserSession();
  var tmp = WebSocketClient(getServerUrl(), VOID, VOID, VOID, VOID, VOID, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var ws = tmp;
  session.fde_1 = new GameConnection(ws);
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_5()));
  var name = 'sceneContainer';
  var size = Companion_getInstance_1().c2g_1;
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var tmp_0 = views($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var views_0 = tmp_0;
  var width = size.fl();
  var height = size.gl();
  var rwidth = width;
  var rheight = height;
  if (width === 0.0 && height === 0.0) {
    var tmp_1 = findFirstAscendant($this$Korge, main$slambda$lambda);
    var base = (tmp_1 == null ? true : tmp_1 instanceof FixedSizeContainer) ? tmp_1 : null;
    var tmp1_elvis_lhs = base == null ? null : base.m2i();
    rwidth = tmp1_elvis_lhs == null ? views_0.c9l_1.m2i() : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = base == null ? null : base.n2i();
    rheight = tmp3_elvis_lhs == null ? views_0.c9l_1.n2i() : tmp3_elvis_lhs;
  }
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SceneContainer.d9r(views_0, defaultTransition, name, Size2D.b2e(rwidth, rheight));
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
  var sc = addTo(this_0, $this$Korge);
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration(0, DurationUnit_SECONDS_getInstance());
  var transition = sc.y9q_1;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(LoginScene);
  var injects_0 = injects.slice();
  var sceneInjector = sc.x9q_1.s9j_1.v63().t63(getKClass(SceneContainer), sc).t63(getKClass(Resources), new Resources(sc.t14(), sc.x9q_1.z9r().q33_1, sc.x9q_1.z9r()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp_2 = getKClassFromExpression(inject);
    sceneInjector.t63(isInterface(tmp_2, KClass) ? tmp_2 : THROW_CCE(), inject);
  }
  // Inline function 'main.<anonymous>.<anonymous>' call
  var newScene = new LoginScene(session);
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_3().ea7_1;
  var level = Level_INFO_getInstance();
  var tmp_3;
  if (this_1.j2t(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$8 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_1.k2t(level, tmp$ret$8);
    tmp_3 = Unit_instance;
  }
  if (true) {
    newScene.e64(sceneInjector);
    var tmp_4 = getKClassFromExpression(newScene);
    var tmp_5 = isInterface(tmp_4, KClass) ? tmp_4 : THROW_CCE();
    sc.x9q_1.s9j_1.x63(tmp_5, main$slambda$lambda_0(sceneInjector, session));
  }
  var tmp_6 = sc.ga7(newScene, time, transition, $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  return Unit_instance;
}
function main$slambda$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function main$slambda$lambda_0($sceneInjector, $session) {
  return function ($this$mapPrototype) {
    // Inline function 'main.<anonymous>.<anonymous>' call
    return new LoginScene($session);
  };
}
function main$slambda_0() {
  var i = new main$slambda();
  var l = function ($this$Korge, $completion) {
    return i.l9g($this$Korge, $completion);
  };
  l.$arity = 1;
  return l;
}
function mainWrapper() {
  startCoroutineUninterceptedOrReturnGeneratorVersion(main, get_EmptyContinuation());
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  try {
    var packet = Default_getInstance().od2(Companion_getInstance().lda(), $this.pde_1);
    var tmp = $this.qde_1.tde_1.mdc(packet, $this.qde_1.sde_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Exception) {
      var _unused_var__etf5q3 = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function GameConnection$lambda$slambda_0($bytes, this$0) {
  var i = new GameConnection$lambda$slambda($bytes, this$0);
  var l = function ($this$launch, $completion) {
    return i.w1n($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameConnection$lambda(this$0) {
  return function (bytes) {
    var tmp = GlobalScope_instance;
    launch(tmp, VOID, VOID, GameConnection$lambda$slambda_0(bytes, this$0));
    return Unit_instance;
  };
}
function *_generator_send__qhx0g0($this, packet, $completion) {
  var bytes = Default_getInstance().nd2(Companion_getInstance_0().lda(), packet);
  var tmp = $this.ude_1.o33(bytes, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function GameScene$sceneMain$o$updateGameState$lambda($p) {
  return function (it) {
    return it.qda_1 <= $p.td9_1;
  };
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  try {
    var tmp = $this.wde_1.sde_1.vde($this.xde_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Exception) {
      var _unused_var__etf5q3 = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function _get_worldContainer__rhqz38($this) {
  var tmp = $this.odf_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('worldContainer');
  }
}
function _get_cosmicAssets__r1bx3s($this) {
  var tmp = $this.rdf_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('cosmicAssets');
  }
}
function getChunkKey($this, x, y) {
  return '' + x + ',' + y;
}
function renderChunk($this, layerName, chunk) {
  var tmp0_elvis_lhs = $this.pdf_1.c3(layerName);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var lContainer = tmp;
  var chunkKey = getChunkKey($this, chunk.tdc_1, chunk.udc_1);
  var tmp1_safe_receiver = $this.qdf_1.c3(layerName);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f3(chunkKey);
  if (tmp2_safe_receiver == null)
    null;
  else {
    tmp2_safe_receiver.wai();
  }
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.na3(false);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.container.<anonymous>' call
  var cContainer = addTo(this_0, lContainer);
  // Inline function 'kotlin.collections.set' call
  // Inline function 'kotlin.collections.getOrPut' call
  var this_1 = $this.qdf_1;
  var value = this_1.c3(layerName);
  var tmp_0;
  if (value == null) {
    // Inline function 'korlibs.samples.clientserver.scenes.GameScene.renderChunk.<anonymous>' call
    // Inline function 'kotlin.collections.mutableMapOf' call
    var answer = LinkedHashMap.bc();
    this_1.e3(layerName, answer);
    tmp_0 = answer;
  } else {
    tmp_0 = value;
  }
  tmp_0.e3(chunkKey, cContainer);
  var inductionVariable = 0;
  var last = chunk.rdc_1;
  if (inductionVariable < last)
    do {
      var r = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = chunk.sdc_1;
      if (inductionVariable_0 < last_0)
        $l$loop: do {
          var c = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var gid = chunk.qdc_1.d1(imul(r, chunk.sdc_1) + c | 0);
          if (gid === 0)
            continue $l$loop;
          var idx = gid - 1 | 0;
          var colInSheet = idx % $this.udf_1 | 0;
          var rowInSheet = idx / $this.udf_1 | 0;
          // Inline function 'kotlin.collections.getOrPut' call
          var this_2 = $this.sdf_1;
          var value_0 = this_2.c3(gid);
          var tmp_1;
          if (value_0 == null) {
            // Inline function 'korlibs.samples.clientserver.scenes.GameScene.renderChunk.<anonymous>' call
            var answer_0 = slice(extract(slice(_get_cosmicAssets__r1bx3s($this), RectangleInt.u2e(imul(colInSheet, $this.tdf_1), imul(rowInSheet, $this.tdf_1), $this.tdf_1, $this.tdf_1))));
            this_2.e3(gid, answer_0);
            tmp_1 = answer_0;
          } else {
            tmp_1 = value_0;
          }
          var slice_0 = tmp_1;
          // Inline function 'kotlin.apply' call
          // Inline function 'korlibs.korge.view.xy' call
          // Inline function 'korlibs.korge.view.image' call
          var anchor = Companion_getInstance_2().f24_1;
          // Inline function 'korlibs.korge.view.addTo' call
          var this_3 = Image.ubd(slice_0, anchor);
          // Inline function 'kotlin.apply' call
          var this_4 = addTo(this_3, cContainer);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.image.<anonymous>' call
          var x = imul(chunk.tdc_1 + c | 0, $this.tdf_1);
          var y = imul(chunk.udc_1 + r | 0, $this.tdf_1);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.samples.clientserver.scenes.GameScene.renderChunk.<anonymous>' call
          xy(this_4, numberToDouble(x), numberToDouble(y)).xc1_1 = false;
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
}
function *_generator_sceneMain__5xvlzl(_this__u8e3s4, $this, $completion) {
  var tmp0_elvis_lhs = $this.idf_1.fde_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var conn = tmp;
  var tmp_0 = $this;
  var tmp_1 = readBitmap(get_resourcesVfs().bi('sprites/world/cosmic_assets.png'), VOID, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  tmp_0.rdf_1 = tmp_1;
  var tmp_2 = $this;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.na3(false);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.container.<anonymous>' call
  tmp_2.odf_1 = addTo(this_0, _this__u8e3s4);
  scale(_get_worldContainer__rhqz38($this), 3.0);
  var tmp_3 = readBitmap(get_resourcesVfs().bi('sprites/player/idle.png'), VOID, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var playerIdle = tmp_3;
  var playerAnimation = Companion_instance.scn(playerIdle, 16, 32);
  var tmp_4 = readTtfFont(get_resourcesVfs().bi('PressStart2P.ttf'), VOID, VOID, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var pixelFont = tmp_4;
  // Inline function 'korlibs.korge.view.xy' call
  // Inline function 'korlibs.korge.view.container' call
  var this_1 = _get_worldContainer__rhqz38($this);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = Container.na3(false);
  // Inline function 'kotlin.apply' call
  var this_3 = addTo(this_2, this_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.container.<anonymous>' call
  var localPlayerView = xy(this_3, numberToDouble(0.0), numberToDouble(0.0));
  // Inline function 'kotlin.apply' call
  // Inline function 'korlibs.korge.view.sprite' call
  var anchor_0 = Companion_getInstance_2().f24_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_4 = Sprite.lcn(playerAnimation, anchor_0);
  // Inline function 'kotlin.apply' call
  var this_5 = addTo(this_4, localPlayerView);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.sprite.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.samples.clientserver.scenes.GameScene.sceneMain.<anonymous>' call
  this_5.xc1_1 = false;
  // Inline function 'korlibs.korge.view.anchor' call
  anchor(this_5, Anchor2D.s24(numberToDouble(0.5), numberToDouble(0.5)));
  var localPlayerSprite = this_5;
  // Inline function 'korlibs.time.seconds' call
  var tmp$ret$15 = toDuration(0.2, DurationUnit_SECONDS_getInstance());
  localPlayerSprite.pcn(VOID, tmp$ret$15);
  // Inline function 'kotlin.apply' call
  var tmp1_text = $this.idf_1.cde_1;
  var tmp2_color = Colors_getInstance().s3y_1;
  // Inline function 'korlibs.korge.view.text' call
  var alignment = Companion_getInstance_6().y4w_1;
  var renderer = get_DefaultStringTextRenderer();
  var autoScaling = Companion_instance_0.ubo_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_6 = Text.vbo(tmp1_text, numberToDouble(4.0), tmp2_color, pixelFont, alignment, renderer, autoScaling, null, null);
  // Inline function 'kotlin.apply' call
  var this_7 = addTo(this_6, localPlayerView);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.text.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.samples.clientserver.scenes.GameScene.sceneMain.<anonymous>' call
  this_7.jao_1 = false;
  // Inline function 'korlibs.korge.view.xy' call
  var y = -20.0;
  xy(this_7, numberToDouble(0.0), numberToDouble(y));
  var localNametag = this_7;
  var myPlayerId = $this.idf_1.ede_1;
  var gameContext = new GameScene$sceneMain$gameContext$1($this, localPlayerView, playerAnimation, pixelFont);
  // Inline function 'kotlin.collections.set' call
  var this_8 = $this.jdf_1;
  var key = $this.idf_1.ede_1;
  this_8.e3(key, localPlayerView);
  // Inline function 'kotlin.collections.set' call
  var this_9 = $this.ldf_1;
  var key_0 = $this.idf_1.ede_1;
  this_9.e3(key_0, localNametag);
  // Inline function 'korlibs.samples.clientserver.networking.PacketDispatcher.register' call
  var this_10 = conn.tde_1;
  var handler = new GameStateHandler(gameContext);
  this_10.ldc(getKClass(GameState), handler);
  // Inline function 'korlibs.samples.clientserver.networking.PacketDispatcher.register' call
  var this_11 = conn.tde_1;
  var handler_0 = new MapDataHandler(gameContext);
  this_11.ldc(getKClass(MapDataPacket), handler_0);
  // Inline function 'korlibs.samples.clientserver.networking.PacketDispatcher.register' call
  var this_12 = conn.tde_1;
  var handler_1 = new MapChunkUpdateHandler(gameContext);
  this_12.ldc(getKClass(MapChunkUpdatePacket), handler_1);
  var currentSequenceNumber = {_v: 0};
  var netDx = {_v: 0.0};
  var netDy = {_v: 0.0};
  addUpdater(_this__u8e3s4, GameScene$sceneMain$lambda($this, netDx, netDy, localPlayerView, gameContext));
  var tmp_5 = get_timesPerSecond(40);
  addFixedUpdater(_this__u8e3s4, tmp_5, VOID, VOID, GameScene$sceneMain$lambda_0(netDx, netDy, currentSequenceNumber, $this, conn));
  return Unit_instance;
}
function GameScene$sceneMain$lambda(this$0, $netDx, $netDy, $localPlayerView, $gameContext) {
  return function ($this$addUpdater, dt) {
    var dx = 0.0;
    var dy = 0.0;
    var tmp;
    if (this$0.d9x().t9j_1.w83_1.d83(Key_W_getInstance())) {
      dy = dy - 1.0;
      tmp = Unit_instance;
    }
    var tmp_0;
    if (this$0.d9x().t9j_1.w83_1.d83(Key_S_getInstance())) {
      dy = dy + 1.0;
      tmp_0 = Unit_instance;
    }
    var tmp_1;
    if (this$0.d9x().t9j_1.w83_1.d83(Key_A_getInstance())) {
      dx = dx - 1.0;
      tmp_1 = Unit_instance;
    }
    var tmp_2;
    if (this$0.d9x().t9j_1.w83_1.d83(Key_D_getInstance())) {
      dx = dx + 1.0;
      tmp_2 = Unit_instance;
    }
    var tmp_3;
    if (!(dx === 0.0) || !(dy === 0.0)) {
      // Inline function 'kotlin.math.hypot' call
      var x = dx;
      var y = dy;
      var length = hypot(x, y);
      dx = dx / length;
      dy = dy / length;
      tmp_3 = Unit_instance;
    }
    $netDx._v = dx;
    $netDy._v = dy;
    var radius = 6.0;
    var currentX = $localPlayerView.t6a();
    var currentY = $localPlayerView.u6a();
    var map = this$0.ndf_1;
    var tmp_4;
    if (!(map == null)) {
      if (!(dx === 0.0)) {
        currentX = map.ndd(currentX, currentY, dx, 150.0 * get_seconds(dt.kj_1), radius);
      }
      var tmp_5;
      if (!(dy === 0.0)) {
        currentY = map.odd(currentX, currentY, dy, 150.0 * get_seconds(dt.kj_1), radius);
        tmp_5 = Unit_instance;
      }
      tmp_4 = tmp_5;
    }
    $localPlayerView.fah(currentX);
    $localPlayerView.gah(currentY);
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this$0.mdf_1.p1().a1();
    $l$loop_0: while (_iterator__ex2g4s.b1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.c1();
      // Inline function 'kotlin.collections.component1' call
      var id = _destruct__k2r9zo.q1();
      // Inline function 'kotlin.collections.component2' call
      var target = _destruct__k2r9zo.r1();
      var tmp0_elvis_lhs = this$0.jdf_1.c3(id);
      var tmp_6;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop_0;
      } else {
        tmp_6 = tmp0_elvis_lhs;
      }
      var view = tmp_6;
      if (id === $gameContext.xdf_1)
        continue $l$loop_0;
      var lerpSpeed = 15.0;
      // Inline function 'kotlin.math.exp' call
      var x_0 = -lerpSpeed * get_seconds(dt.kj_1);
      var t = 1.0 - Math.exp(x_0);
      view.fah(view.t6a() + (target.vdf_1 - view.t6a()) * t);
      view.gah(view.u6a() + (target.wdf_1 - view.u6a()) * t);
    }
    _get_worldContainer__rhqz38(this$0).fah(round(400.0 - $localPlayerView.t6a() * 3.0));
    _get_worldContainer__rhqz38(this$0).gah(round(300.0 - $localPlayerView.u6a() * 3.0));
    return Unit_instance;
  };
}
function GameScene$sceneMain$lambda$slambda_0($conn, $moveData) {
  var i = new GameScene$sceneMain$lambda$slambda($conn, $moveData);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function GameScene$sceneMain$lambda_0($netDx, $netDy, $currentSequenceNumber, this$0, $conn) {
  return function ($this$addFixedUpdater) {
    var tmp;
    if (!($netDx._v === 0.0) || !($netDy._v === 0.0)) {
      var _unary__edvuaz = $currentSequenceNumber._v;
      $currentSequenceNumber._v = _unary__edvuaz + 1 | 0;
      var moveData = new MovePacket($currentSequenceNumber._v, $netDx._v, $netDy._v);
      this$0.kdf_1.h(moveData);
      launchImmediately(this$0, GameScene$sceneMain$lambda$slambda_0($conn, moveData));
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp0_subject = $this.cdg_1.wda_1;
  if (tmp0_subject === 0) {
    $this.ddg_1.sdg_1.cde_1 = $this.cdg_1.xda_1;
    $this.ddg_1.sdg_1.ede_1 = $this.cdg_1.yda_1;
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
    var this_0 = $this.ddg_1.ca1();
    var injects = [];
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var time = toDuration(0, DurationUnit_SECONDS_getInstance());
    var transition = this_0.y9q_1;
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
    var clazz = getKClass(GameScene);
    var injects_0 = injects.slice();
    var sceneInjector = this_0.x9q_1.s9j_1.v63().t63(getKClass(SceneContainer), this_0).t63(getKClass(Resources), new Resources(this_0.t14(), this_0.x9q_1.z9r().q33_1, this_0.x9q_1.z9r()));
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < injects_0.length) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var inject = injects_0[_unary__edvuaz];
      var tmp = getKClassFromExpression(inject);
      sceneInjector.t63(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
    }
    // Inline function 'korlibs.samples.clientserver.scenes.LoginScene.sceneMain.<anonymous>.<anonymous>.<anonymous>' call
    var newScene = new GameScene($this.ddg_1.sdg_1);
    // Inline function 'korlibs.logger.Logger.info' call
    var this_1 = Companion_getInstance_3().ea7_1;
    var level = Level_INFO_getInstance();
    var tmp_0;
    if (this_1.j2t(level)) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var tmp$ret$3 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
      this_1.k2t(level, tmp$ret$3);
      tmp_0 = Unit_instance;
    }
    if (true) {
      newScene.e64(sceneInjector);
      var tmp_1 = getKClassFromExpression(newScene);
      var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
      this_0.x9q_1.s9j_1.x63(tmp_2, LoginScene$sceneMain$o$handle$slambda$lambda(sceneInjector, $this.ddg_1));
    }
    var tmp_3 = this_0.ga7(newScene, time, transition, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  } else if (tmp0_subject === 1) {
    $this.edg_1.l8j(false);
    showLoginRegisterUI($this.ddg_1, $this.fdg_1, $this.gdg_1, $this.hdg_1);
  }
  return Unit_instance;
}
function LoginScene$sceneMain$o$handle$slambda$lambda($sceneInjector, this$0) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.samples.clientserver.scenes.LoginScene.sceneMain.<anonymous>.<anonymous>.<anonymous>' call
    return new GameScene(this$0.sdg_1);
  };
}
function LoginScene$sceneMain$o$handle$slambda_1($packet, this$0, $statusText, $this_sceneMain, $pixelFont, $conn) {
  var i = new LoginScene$sceneMain$o$handle$slambda($packet, this$0, $statusText, $this_sceneMain, $pixelFont, $conn);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function LoginScene$sceneMain$o$handle$slambda_2($packet, this$0) {
  var i = new LoginScene$sceneMain$o$handle$slambda_0($packet, this$0);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  try {
    var tmp = $this.vdg_1.sde_1.vde(new AuthHandshakeRequest($this.wdg_1.sdg_1.dde_1), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Exception) {
      var _unused_var__etf5q3 = $p;
      $this.xdg_1.lal('CONNECTION\nFAILED');
      $this.xdg_1.wav(Colors_getInstance().k4e('#FF4444'));
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function LoginScene$showLoginRegisterUI$o$handle$slambda_0($packet, $errorText) {
  var i = new LoginScene$showLoginRegisterUI$o$handle$slambda($packet, $errorText);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  try {
    var tmp = $this.adh_1.sde_1.vde(new LoginRequest($this.bdh_1, $this.cdh_1), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Exception) {
      var _unused_var__etf5q3 = $p;
      $this.ddh_1.lal('CONNECTION ERROR');
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  try {
    var tmp = $this.edh_1.sde_1.vde(new RegisterRequest($this.fdh_1, $this.gdh_1), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Exception) {
      var _unused_var__etf5q3 = $p;
      $this.hdh_1.lal('CONNECTION ERROR');
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_sceneMain__5xvlzl_0(_this__u8e3s4, $this, $completion) {
  var tmp = readTtfFont(get_resourcesVfs().bi('PressStart2P.ttf'), VOID, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var pixelFont = tmp;
  var tmp0_elvis_lhs = $this.sdg_1.fde_1;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var conn = tmp_0;
  // Inline function 'korlibs.korge.view.solidRect' call
  var color = Colors_getInstance().k4e('#101018');
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SolidRect.eck(Size2D.b2e(800.0, 600.0), color);
  // Inline function 'kotlin.apply' call
  addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  // Inline function 'kotlin.apply' call
  var tmp1_color = Colors_getInstance().k4e('#8F8FA6');
  // Inline function 'korlibs.korge.view.text' call
  var text = 'CONNECTING...';
  var alignment = Companion_getInstance_6().l4w_1;
  var renderer = get_DefaultStringTextRenderer();
  var autoScaling = Companion_instance_0.ubo_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = Text.vbo(text, numberToDouble(10.0), tmp1_color, pixelFont, alignment, renderer, autoScaling, null, null);
  // Inline function 'kotlin.apply' call
  var this_2 = addTo(this_1, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.text.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.samples.clientserver.scenes.LoginScene.sceneMain.<anonymous>' call
  this_2.jao_1 = false;
  this_2.eco(Companion_getInstance_6().y4w_1);
  // Inline function 'korlibs.korge.view.xy' call
  xy(this_2, numberToDouble(400.0), numberToDouble(300.0));
  var statusText = this_2;
  var tmp2_elvis_lhs = loadSessionToken();
  var savedToken = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
  $this.sdg_1.dde_1 = savedToken;
  // Inline function 'korlibs.samples.clientserver.networking.PacketDispatcher.register' call
  var this_3 = conn.tde_1;
  var tmp_1 = getKClass(AuthHandshakeResponse);
  this_3.ldc(tmp_1, new _no_name_provided__qut3iv($this, statusText, _this__u8e3s4, pixelFont, conn));
  // Inline function 'korlibs.samples.clientserver.networking.PacketDispatcher.register' call
  var this_4 = conn.tde_1;
  var tmp_2 = getKClass(AuthStatusResponse);
  this_4.ldc(tmp_2, new _no_name_provided__qut3iv_0($this));
  launchImmediately($this, LoginScene$sceneMain$slambda_0(conn, $this, statusText));
  return Unit_instance;
}
function showLoginRegisterUI($this, container, pixelFont, conn) {
  // Inline function 'kotlin.apply' call
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.na3(false);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, container);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.container.<anonymous>' call
  var this_2 = xy(this_1, 400.0, 300.0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.samples.clientserver.scenes.LoginScene.showLoginRegisterUI.<anonymous>' call
  // Inline function 'korlibs.korge.view.anchor' call
  // Inline function 'korlibs.korge.view.solidRect' call
  var color = Colors_getInstance().k4e('#00FFCC');
  // Inline function 'korlibs.korge.view.addTo' call
  var this_3 = SolidRect.eck(Size2D.b2e(400.0, 320.0), color);
  // Inline function 'kotlin.apply' call
  var this_4 = addTo(this_3, this_2);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  anchor(this_4, Anchor2D.s24(numberToDouble(0.5), numberToDouble(0.5)));
  // Inline function 'korlibs.korge.view.anchor' call
  // Inline function 'korlibs.korge.view.solidRect' call
  var color_0 = Colors_getInstance().k4e('#11111E');
  // Inline function 'korlibs.korge.view.addTo' call
  var this_5 = SolidRect.eck(Size2D.b2e(396.0, 316.0), color_0);
  // Inline function 'kotlin.apply' call
  var this_6 = addTo(this_5, this_2);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  anchor(this_6, Anchor2D.s24(numberToDouble(0.5), numberToDouble(0.5)));
  // Inline function 'kotlin.apply' call
  var tmp0_color = Colors_getInstance().k4e('#00FFCC');
  // Inline function 'korlibs.korge.view.text' call
  var text = 'XENO ONLINE';
  var alignment = Companion_getInstance_6().l4w_1;
  var renderer = get_DefaultStringTextRenderer();
  var autoScaling = Companion_instance_0.ubo_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_7 = Text.vbo(text, numberToDouble(22.0), tmp0_color, pixelFont, alignment, renderer, autoScaling, null, null);
  // Inline function 'kotlin.apply' call
  var this_8 = addTo(this_7, this_2);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.text.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.samples.clientserver.scenes.LoginScene.showLoginRegisterUI.<anonymous>.<anonymous>' call
  this_8.jao_1 = false;
  this_8.eco(Companion_getInstance_6().y4w_1);
  // Inline function 'korlibs.korge.view.xy' call
  var y = -110.0;
  xy(this_8, numberToDouble(0.0), numberToDouble(y));
  // Inline function 'kotlin.apply' call
  var tmp1_color = Colors_getInstance().s3y_1;
  // Inline function 'korlibs.korge.view.text' call
  var text_0 = 'USERNAME:';
  var alignment_0 = Companion_getInstance_6().l4w_1;
  var renderer_0 = get_DefaultStringTextRenderer();
  var autoScaling_0 = Companion_instance_0.ubo_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_9 = Text.vbo(text_0, numberToDouble(8.0), tmp1_color, pixelFont, alignment_0, renderer_0, autoScaling_0, null, null);
  // Inline function 'kotlin.apply' call
  var this_10 = addTo(this_9, this_2);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.text.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.samples.clientserver.scenes.LoginScene.showLoginRegisterUI.<anonymous>.<anonymous>' call
  this_10.jao_1 = false;
  this_10.eco(Companion_getInstance_6().t4w_1);
  // Inline function 'korlibs.korge.view.xy' call
  var x = -140.0;
  var y_0 = -70.0;
  xy(this_10, numberToDouble(x), numberToDouble(y_0));
  // Inline function 'korlibs.korge.ui.uiTextInput' call
  var size = Size2D.l26(128, 24);
  // Inline function 'kotlin.also' call
  var this_11 = addTo(UITextInput.fbm('', size), this_2);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.ui.uiTextInput.<anonymous>' call
  // Inline function 'korlibs.samples.clientserver.scenes.LoginScene.showLoginRegisterUI.<anonymous>.<anonymous>' call
  this_11.bbe(280.0);
  this_11.cbe(32.0);
  // Inline function 'korlibs.korge.view.xy' call
  var x_0 = -140.0;
  var y_1 = -60.0;
  xy(this_11, numberToDouble(x_0), numberToDouble(y_1));
  var usernameInput = this_11;
  // Inline function 'kotlin.apply' call
  var tmp2_color = Colors_getInstance().s3y_1;
  // Inline function 'korlibs.korge.view.text' call
  var text_1 = 'PASSWORD:';
  var alignment_1 = Companion_getInstance_6().l4w_1;
  var renderer_1 = get_DefaultStringTextRenderer();
  var autoScaling_1 = Companion_instance_0.ubo_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_12 = Text.vbo(text_1, numberToDouble(8.0), tmp2_color, pixelFont, alignment_1, renderer_1, autoScaling_1, null, null);
  // Inline function 'kotlin.apply' call
  var this_13 = addTo(this_12, this_2);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.text.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.samples.clientserver.scenes.LoginScene.showLoginRegisterUI.<anonymous>.<anonymous>' call
  this_13.jao_1 = false;
  this_13.eco(Companion_getInstance_6().t4w_1);
  // Inline function 'korlibs.korge.view.xy' call
  var x_1 = -140.0;
  var y_2 = -10.0;
  xy(this_13, numberToDouble(x_1), numberToDouble(y_2));
  // Inline function 'korlibs.korge.ui.uiTextInput' call
  var size_0 = Size2D.l26(128, 24);
  // Inline function 'kotlin.also' call
  var this_14 = addTo(UITextInput.fbm('', size_0), this_2);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.ui.uiTextInput.<anonymous>' call
  // Inline function 'korlibs.samples.clientserver.scenes.LoginScene.showLoginRegisterUI.<anonymous>.<anonymous>' call
  this_14.bbe(280.0);
  this_14.cbe(32.0);
  // Inline function 'korlibs.korge.view.xy' call
  var x_2 = -140.0;
  xy(this_14, numberToDouble(x_2), numberToDouble(0.0));
  var passwordInput = this_14;
  // Inline function 'kotlin.apply' call
  // Inline function 'korlibs.korge.view.text' call
  var color_1 = Colors_getInstance().k4e('#FF4444');
  var alignment_2 = Companion_getInstance_6().l4w_1;
  var renderer_2 = get_DefaultStringTextRenderer();
  var autoScaling_2 = Companion_instance_0.ubo_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_15 = Text.vbo('', numberToDouble(6.0), color_1, pixelFont, alignment_2, renderer_2, autoScaling_2, null, null);
  // Inline function 'kotlin.apply' call
  var this_16 = addTo(this_15, this_2);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.text.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.samples.clientserver.scenes.LoginScene.showLoginRegisterUI.<anonymous>.<anonymous>' call
  this_16.jao_1 = false;
  this_16.eco(Companion_getInstance_6().y4w_1);
  // Inline function 'korlibs.korge.view.xy' call
  xy(this_16, numberToDouble(0.0), numberToDouble(45.0));
  var errorText = this_16;
  // Inline function 'korlibs.samples.clientserver.networking.PacketDispatcher.register' call
  var this_17 = conn.tde_1;
  var tmp = getKClass(AuthStatusResponse);
  this_17.ldc(tmp, new _no_name_provided__qut3iv_1($this, errorText));
  // Inline function 'korlibs.korge.ui.uiButton' call
  var size_1 = Companion_getInstance_4().hax_1;
  // Inline function 'kotlin.apply' call
  var this_18 = addTo(UIButton.vb7(size_1, 'LOGIN', null), this_2);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.samples.clientserver.scenes.LoginScene.showLoginRegisterUI.<anonymous>.<anonymous>' call
  this_18.bbe(130.0);
  this_18.cbe(36.0);
  // Inline function 'korlibs.korge.view.xy' call
  var x_3 = -140.0;
  xy(this_18, numberToDouble(x_3), numberToDouble(70.0));
  // Inline function 'korlibs.korge.input.onClick' call
  var handler = LoginScene$showLoginRegisterUI$lambda(usernameInput, passwordInput, errorText, $this, conn);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop = click$factory();
  var tmp1_safe_receiver = this_18 == null ? null : this_18.sag();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp1_safe_receiver.e1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp0_safe_receiver = tmp1_safe_receiver.d1(_unary__edvuaz);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0 = prop.get(tmp1_safe_receiver_0);
        tmp_0.x1v(LoginScene$showLoginRegisterUI$lambda_0(handler));
      }
    }
  }
  // Inline function 'korlibs.korge.ui.uiButton' call
  var label = 'REGISTER';
  var size_2 = Companion_getInstance_4().hax_1;
  // Inline function 'kotlin.apply' call
  var this_19 = addTo(UIButton.vb7(size_2, label, null), this_2);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.samples.clientserver.scenes.LoginScene.showLoginRegisterUI.<anonymous>.<anonymous>' call
  this_19.bbe(130.0);
  this_19.cbe(36.0);
  // Inline function 'korlibs.korge.view.xy' call
  xy(this_19, numberToDouble(10.0), numberToDouble(70.0));
  // Inline function 'korlibs.korge.input.onClick' call
  var handler_0 = LoginScene$showLoginRegisterUI$lambda_1(usernameInput, passwordInput, errorText, $this, conn);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_0 = click$factory_0();
  var tmp1_safe_receiver_1 = this_19 == null ? null : this_19.sag();
  if (tmp1_safe_receiver_1 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < tmp1_safe_receiver_1.e1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var tmp0_safe_receiver_0 = tmp1_safe_receiver_1.d1(_unary__edvuaz_0);
      var tmp1_safe_receiver_2 = tmp0_safe_receiver_0 == null ? null : get_mouse(tmp0_safe_receiver_0);
      if (tmp1_safe_receiver_2 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_1 = prop_0.get(tmp1_safe_receiver_2);
        tmp_1.x1v(LoginScene$showLoginRegisterUI$lambda_2(handler_0));
      }
    }
  }
}
function LoginScene$sceneMain$slambda_0($conn, this$0, $statusText) {
  var i = new LoginScene$sceneMain$slambda($conn, this$0, $statusText);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function LoginScene$showLoginRegisterUI$lambda$slambda_1($conn, $user, $pass, $errorText) {
  var i = new LoginScene$showLoginRegisterUI$lambda$slambda($conn, $user, $pass, $errorText);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function LoginScene$showLoginRegisterUI$lambda($usernameInput, $passwordInput, $errorText, this$0, $conn) {
  return function (it) {
    // Inline function 'kotlin.text.trim' call
    var this_0 = $usernameInput.w5q();
    var user = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    var pass = $passwordInput.w5q();
    var tmp;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(user) === 0) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.text.isEmpty' call
      tmp_0 = charSequenceLength(pass) === 0;
    }
    if (tmp_0) {
      $errorText.lal('FIELDS CANNOT BE EMPTY');
      return Unit_instance;
    }
    launchImmediately(this$0, LoginScene$showLoginRegisterUI$lambda$slambda_1($conn, user, pass, $errorText));
    return Unit_instance;
  };
}
function LoginScene$showLoginRegisterUI$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function LoginScene$showLoginRegisterUI$lambda$slambda_2($conn, $user, $pass, $errorText) {
  var i = new LoginScene$showLoginRegisterUI$lambda$slambda_0($conn, $user, $pass, $errorText);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function LoginScene$showLoginRegisterUI$lambda_1($usernameInput, $passwordInput, $errorText, this$0, $conn) {
  return function (it) {
    // Inline function 'kotlin.text.trim' call
    var this_0 = $usernameInput.w5q();
    var user = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    var pass = $passwordInput.w5q();
    var tmp;
    if (user.length < 3) {
      $errorText.lal('USER MIN 3 CHARS');
      return Unit_instance;
    }
    var tmp_0;
    if (pass.length < 6) {
      $errorText.lal('PASS MIN 6 CHARS');
      return Unit_instance;
    }
    launchImmediately(this$0, LoginScene$showLoginRegisterUI$lambda$slambda_2($conn, user, pass, $errorText));
    return Unit_instance;
  };
}
function LoginScene$showLoginRegisterUI$lambda_2($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function click$factory() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.m9v_1;
  }, null);
}
function click$factory_0() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.m9v_1;
  }, null);
}
function getServerUrl() {
  var hostname = window.location.hostname;
  var protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
  var tmp;
  switch (hostname) {
    case 'localhost':
    case '127.0.0.1':
      tmp = 'localhost:8080';
      break;
    default:
      tmp = 'xeno-api.bradenkennedy.com';
      break;
  }
  var server = tmp;
  return protocol + '://' + server + '/game';
}
function saveSessionToken(token) {
  window.localStorage.setItem('xeno_session_token', token);
}
function loadSessionToken() {
  return window.localStorage.getItem('xeno_session_token');
}
//region block: post-declaration
initMetadataForClass(UserSession, 'UserSession', UserSession);
initMetadataForClass(GameStateHandler, 'GameStateHandler', VOID, VOID, [PacketHandler], [2]);
initMetadataForClass(MapChunkUpdateHandler, 'MapChunkUpdateHandler', VOID, VOID, [PacketHandler], [2]);
initMetadataForClass(MapDataHandler, 'MapDataHandler', VOID, VOID, [PacketHandler], [2]);
initMetadataForLambda(main$slambda, VOID, VOID, [1]);
initMetadataForLambda(GameConnection$lambda$slambda, VOID, VOID, [1]);
initMetadataForClass(GameConnection, 'GameConnection');
initMetadataForClass(KorGeClientContext, 'KorGeClientContext', VOID, VOID, [ClientContext], [1]);
initMetadataForClass(TargetPos, 'TargetPos');
initMetadataForClass(GameScene$sceneMain$gameContext$1);
initMetadataForLambda(GameScene$sceneMain$lambda$slambda, VOID, VOID, [0]);
initMetadataForClass(GameScene, 'GameScene', VOID, VOID, VOID, [0]);
initMetadataForLambda(LoginScene$sceneMain$o$handle$slambda, VOID, VOID, [0]);
initMetadataForLambda(LoginScene$sceneMain$o$handle$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(LoginScene$showLoginRegisterUI$o$handle$slambda, VOID, VOID, [0]);
initMetadataForClass(_no_name_provided__qut3iv, VOID, VOID, VOID, [PacketHandler], [2]);
initMetadataForClass(_no_name_provided__qut3iv_0, VOID, VOID, VOID, [PacketHandler], [2]);
initMetadataForLambda(LoginScene$sceneMain$slambda, VOID, VOID, [0]);
initMetadataForClass(_no_name_provided__qut3iv_1, VOID, VOID, VOID, [PacketHandler], [2]);
initMetadataForLambda(LoginScene$showLoginRegisterUI$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(LoginScene$showLoginRegisterUI$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForClass(LoginScene, 'LoginScene', VOID, VOID, VOID, [0]);
//endregion
mainWrapper();
